/**
 * Punto de extensión: un adorno al lado de un campo, en los formularios de alta
 * y edición y en la vista de una entidad con .projectSlots (por ejemplo, un tic
 * de "dato validado"). El PROYECTO llena este archivo; el generador lo emite
 * SIEMPRE con este mismo contenido estable, así el merge base→develop preserva
 * la versión llenada (mismo contrato que formExtras.tsx).
 *
 * Solo en las entidades marcadas con .projectSlots en el DSL, y también en los
 * formularios de sus proyecciones (FieldAdornmentProps no dice de cuál viene).
 *
 * La clave es el nombre de la entidad ("AuthorComposer"). El componente se
 * dibuja al lado de CADA campo simple de esa entidad —texto, número, fecha,
 * booleano, enum o referencia simple; no multilang, listas, archivos,
 * subentidades, secretos ni textos tapados, workflow, campos de auditoría ni
 * de historial, ni textos con editor html o de código; en alta y edición,
 * tampoco los de solo lectura, los llenados por el server ni los visibles solo
 * para algunos roles— y decide por field si muestra algo.
 *
 * Contrato de props:
 *  - entity:   el nombre de la entidad.
 *  - field:    el nombre del campo.
 *  - mode:     "create", "update" o "view".
 *  - recordId: el id del registro. En "create" no hay. En "update" y "view"
 *              llega cuando el formulario ya lo recibe (las entidades con
 *              validación de datos por mail; en la edición, también las que
 *              tienen campos propios; en la vista, los snapshots); si no, undefined.
 *  - value:    el valor actual del campo (en alta y edición, lo que la persona
 *              va escribiendo; en una referencia, { id, displayId } o null).
 *
 * NO EDITAR este stub en el generador: cualquier cambio acá conflictúa con
 * todos los proyectos que lo hayan llenado.
 */
import type { ComponentType } from 'react';
import { AuthorFieldAdornment } from "../../entities/authorComposer/components/common/AuthorFieldAdornment";

export interface FieldAdornmentProps {
  entity: string;
  field: string;
  recordId?: string;
  mode: 'create' | 'update' | 'view';
  value?: unknown;
}

// Lleno por Jupiter: el tic "Dato validado con DNI" en los campos del autor.
export const fieldAdornments: Partial<Record<string, ComponentType<FieldAdornmentProps>>> = {
  AuthorComposer: AuthorFieldAdornment,
};
